import { GuardianRelation } from '@dreryk/egabinet-patient-frontend-api';

import { FormContextValues } from '@dreryk/react-common';

import { GuardianDetailsFormBean } from './GuardianDetailsModal/GuardianDetailsModal';

export enum StatutoryRepresentative {
   YES = 'yes',
   NO = 'no',
}

export type GuardianModalFormBean = {
   guardian: GuardianDetailsFormBean | null;
   fullName: string | null;
   relationCode: GuardianRelation;
   statutoryRepresentative: StatutoryRepresentative;
};

export type GuardianModalFormController = FormContextValues<GuardianModalFormBean>;
